import { z } from "zod";
import { ExampleToneDefinitionId } from "../exampleToneDefinitions.js";
import { openAiSupportedLanguages } from "../openAiSupportedLanguages.js";

export const ToneDefinitionIdSchema = z.union([
  z.uuid(),
  z.enum(ExampleToneDefinitionId),
]);

export const ToneDefinitionSchema = z.object({
  id: ToneDefinitionIdSchema,
  organizationId: z.uuid(),
  createdAt: z.date(),
  removedAt: z.date().nullable(),

  title: z.string().min(3).max(128),
  positiveInstructions: z.string().min(3).max(2048),
  negativeInstructions: z.string().nullable(),
  language: z.string(),
});

export const CreateToneDefinitionSchema = z.object({
  title: ToneDefinitionSchema.shape.title,
  positiveInstructions: ToneDefinitionSchema.shape.positiveInstructions,
  language: z.enum(openAiSupportedLanguages),
});

export const UpdateToneDefinitionSchema = z.object({
  title: CreateToneDefinitionSchema.shape.title.optional(),
  positiveInstructions:
    CreateToneDefinitionSchema.shape.positiveInstructions.optional(),
  language: CreateToneDefinitionSchema.shape.language.optional(),
});

export type ToneDefinition = z.infer<typeof ToneDefinitionSchema>;
export type CreateToneDefinition = z.infer<typeof CreateToneDefinitionSchema>;
export type UpdateToneDefinition = z.infer<typeof UpdateToneDefinitionSchema>;
